// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__k73Bq","toggle":"styles_toggle__A0Cme","switch":"styles_switch__QsQRC"};